import produce from 'immer'
import { CaseworkerActionType } from '../../action-types'
import { CaseworkerAction } from '../../actions'
import { ApiOrganization } from '../../../ts/api-types'

export interface CaseworkerClientOrgsState {
    clients: ApiOrganization[]
    selectedOrganizationInformation: ApiOrganization | null
}

const initialState: CaseworkerClientOrgsState = {
    clients: [],
    selectedOrganizationInformation: null,
}

const reducer = produce(
    (
        state: CaseworkerClientOrgsState = initialState,
        action: CaseworkerAction
    ) => {
        switch (action.type) {
            case CaseworkerActionType.GET_ORGANIZATIONS:
                state.clients = action.payload
                return state

            case CaseworkerActionType.GET_CLIENT_INFORMATION:
                state.selectedOrganizationInformation = action.payload
                return state

            default:
                return state
        }
    }
)

export default reducer
